'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { hexToRgb } from 'src/utils/color/hexToRgb';
import { useCRM } from 'src/context/crm';
import { Checkbox } from 'src/components/PulseUI';

interface StatusFieldOption {
  value: string;
  label: string;
  color?: string;
  bucket: string;
  order?: number;
}

interface GridStatusFilterMenuItemProps {
  option: StatusFieldOption;
  bucket: string;
}

const GridStatusFilterMenuItem: React.FC<GridStatusFilterMenuItemProps> = ({
  option,
  bucket,
}) => {
  const { statusFilterOptions, selectedBuckets, setStatusFilterOptions } =
    useCRM();

  const isChecked = statusFilterOptions?.includes(option.value) || false;
  const isDisabled = selectedBuckets?.includes(bucket);

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    const newOptions = checked
      ? [...statusFilterOptions, option.value]
      : statusFilterOptions.filter((o) => o !== option.value);

    setStatusFilterOptions(newOptions);
  };

  const chipBgColor = hexToRgb(option.color, 0.2);

  return (
    <li
      className="flex items-center px-5 py-1 cursor-pointer"
      data-testid={`status-filter-menu-item-${option.value}`}
      role="menuitemcheckbox"
      aria-checked={isChecked}
    >
      <Checkbox
        size="sm"
        disabled={isDisabled}
        checked={isChecked}
        onChange={handleSelect}
        aria-label={`Filter by ${option.label}`}
        data-testid={`status-filter-checkbox-${option.value}`}
      />
      <span
        className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs"
        style={{
          backgroundColor: chipBgColor,
          color: option.color,
        }}
      >
        <Icon
          icon={faCircle}
          className="text-[0.5rem]"
          aria-hidden="true"
        />
        {option.label}
      </span>
    </li>
  );
};

export default GridStatusFilterMenuItem;
